import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppState } from '@typings';

type State = AppState.PlatformApps['templatesTags'];

const initialState: State = [];

export const platformAppsTemplatesTagsSlice = createSlice({
  name: 'platform-apps-templates-tags',
  initialState,
  reducers: {
    setPlatformAppsTemplatesTags: (state, action: PayloadAction<State>) =>
      action.payload,
    resetPlatformAppsTemplatesTags: () => initialState,
  },
});

export const { setPlatformAppsTemplatesTags, resetPlatformAppsTemplatesTags } =
  platformAppsTemplatesTagsSlice.actions;

export default platformAppsTemplatesTagsSlice.reducer;
